import lazySizes from "lazysizes";
import 'lazysizes/plugins/native-loading/ls.native-loading';
import 'lazysizes/plugins/respimg/ls.respimg';

(function () {

    // Set the loading="lazy" attribute automatically
    lazySizes.cfg.nativeLoading = {
        setLoadingAttribute: true
    }

    document.addEventListener("DOMContentLoaded", (function() {
        const catalogHeaderParagraph = document.querySelector("#catalog_header p");
        if (catalogHeaderParagraph && catalogHeaderParagraph.textContent === '') {
            catalogHeaderParagraph.style.display = 'none';
        }
    }));
})();